var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _rect3, _rect4, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _rect5, _rect6, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _rect7, _rect8, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _rect9, _rect0, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _rect1, _rect10, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path48, _path49, _rect11, _path50, _path51;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCollectiveColdPlunge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 282,
    height: 150,
    viewBox: "0 0 282 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 134.933,
    y: 71.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 134.933 71.9784)",
    fill: "#D5EEFC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 134.933,
    y: 71.9784,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-4 134.933 71.9784)",
    stroke: "#79C7F4",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M152.625 98.4835L151.307 98.8243L153.388 110.984C153.761 113.165 155.727 114.709 157.934 114.554L175.94 113.295C178.147 113.141 179.879 111.339 179.945 109.126L180.313 96.796L178.96 96.642C177.912 96.5228 176.851 96.597 175.83 96.8609L173.194 97.5424C172.172 97.8063 171.112 97.8805 170.064 97.7612L167.358 97.4533C166.31 97.3341 165.249 97.4083 164.228 97.6722L161.591 98.3537C160.57 98.6176 159.509 98.6918 158.461 98.5725L155.755 98.2647C154.707 98.1454 153.647 98.2196 152.625 98.4835Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M164.721 82.2334L165.247 89.7535",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M164.533 79.5479L165.435 92.4394",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M170.341 82.3799L159.627 89.6064",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M159.177 83.1611L170.792 88.8263",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M153.132 109.492L154.119 109.222C155.216 108.922 156.361 108.842 157.49 108.987L159.518 109.247C160.646 109.391 161.792 109.311 162.889 109.011L164.862 108.471C165.959 108.171 167.104 108.091 168.233 108.235L170.261 108.495C171.389 108.64 172.535 108.56 173.632 108.26L175.605 107.72C176.702 107.419 177.847 107.339 178.976 107.484L179.99 107.614",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.22 104.159L153.375 103.852C154.432 103.571 155.534 103.494 156.621 103.625L158.992 103.912C160.079 104.043 161.181 103.966 162.238 103.685L164.547 103.071C165.605 102.79 166.707 102.713 167.793 102.844L170.165 103.131C171.252 103.262 172.353 103.185 173.411 102.904L175.72 102.29C176.778 102.009 177.879 101.932 178.966 102.063L180.152 102.206",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M184.771 91.0866L184.363 91.1152C182.155 91.2695 180.424 93.0717 180.358 95.2838L179.944 109.127C179.878 111.339 178.147 113.141 175.939 113.295L157.934 114.554C155.726 114.709 153.761 113.165 153.387 110.984L151.051 97.3331C150.678 95.1517 148.713 93.6081 146.505 93.7625L146.097 93.791",
    stroke: "#2C94DA",
    strokeWidth: 2.15383,
    strokeLinecap: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 84.949,
    y: 2.98437,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 84.949 2.98437)",
    fill: "#D5EEFC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 84.949,
    y: 2.98437,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(-3 84.949 2.98437)",
    stroke: "#79C7F4",
    strokeWidth: 2
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M102.177 29.7943L100.852 30.1119L102.721 42.3057C103.056 44.4932 104.994 46.0709 107.204 45.9551L125.229 45.0105C127.439 44.8946 129.201 43.123 129.306 40.9124L129.889 28.5902L128.539 28.4126C127.494 28.2751 126.432 28.3308 125.406 28.5768L122.758 29.2122C121.732 29.4583 120.67 29.5139 119.625 29.3764L116.925 29.0213C115.879 28.8838 114.817 28.9395 113.791 29.1856L111.143 29.8209C110.118 30.067 109.056 30.1226 108.01 29.9851L105.31 29.6301C104.264 29.4925 103.202 29.5482 102.177 29.7943Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M114.555 13.7568L114.949 21.285",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M114.413 11.0684L115.089 23.9737",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M120.17 14.002L109.332 21.0403",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M108.996 14.5879L120.51 20.4549",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M102.491 40.8102L103.482 40.5574C104.584 40.2763 105.731 40.2162 106.856 40.3806L108.88 40.6762C110.006 40.8406 111.153 40.7804 112.255 40.4993L114.236 39.9938C115.339 39.7127 116.485 39.6526 117.611 39.817L119.635 40.1125C120.76 40.2769 121.907 40.2168 123.009 39.9357L124.991 39.4302C126.093 39.1491 127.24 39.089 128.365 39.2534L129.377 39.4011",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M101.672 35.4616L102.831 35.1749C103.894 34.9122 104.997 34.8544 106.081 35.0046L108.447 35.3323C109.531 35.4825 110.634 35.4247 111.697 35.162L114.016 34.5887C115.079 34.3261 116.181 34.2683 117.266 34.4184L119.632 34.7462C120.716 34.8963 121.819 34.8385 122.881 34.5759L125.201 34.0026C126.263 33.7399 127.366 33.6821 128.45 33.8323L129.633 33.9961",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M134.447 22.9593L134.038 22.9807C131.828 23.0965 130.065 24.8681 129.96 27.0788L129.305 40.9123C129.201 43.1229 127.438 44.8946 125.228 45.0104L107.203 45.955C104.993 46.0709 103.055 44.4932 102.72 42.3056L100.623 28.6163C100.287 26.4287 98.3492 24.851 96.1392 24.9669L95.7305 24.9883",
    stroke: "#2C94DA",
    strokeWidth: 2.15383,
    strokeLinecap: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 84.9784,
    y: 56.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 84.9784 56.9327)",
    fill: "#D5EEFC"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 84.9784,
    y: 56.9327,
    width: 58,
    height: 58,
    rx: 29,
    transform: "rotate(4 84.9784 56.9327)",
    stroke: "#79C7F4",
    strokeWidth: 2
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8105 85.643L97.4576 85.7969L97.8258 98.1274C97.8919 100.34 99.6234 102.142 101.831 102.296L119.836 103.555C122.044 103.709 124.01 102.166 124.383 99.9845L126.464 87.8252L125.145 87.4845C124.124 87.2206 123.063 87.1464 122.015 87.2656L119.309 87.5735C118.262 87.6927 117.201 87.6186 116.18 87.3546L113.543 86.6732C112.522 86.4092 111.461 86.3351 110.413 86.4543L107.707 86.7622C106.659 86.8814 105.598 86.8072 104.577 86.5433L101.94 85.8618C100.919 85.5979 99.8584 85.5237 98.8105 85.643Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M113.049 71.2334L112.523 78.7535",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M113.237 68.5479L112.336 81.4394",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M118.593 72.1611L106.978 77.8263",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107.43 71.3789L118.143 78.6054",
    stroke: "#2C94DA",
    strokeWidth: 2.15385
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M97.7798 96.6153L98.7941 96.4852C99.9223 96.3404 101.068 96.4206 102.165 96.7209L104.138 97.2609C105.235 97.5612 106.38 97.6413 107.509 97.4966L109.537 97.2364C110.665 97.0917 111.811 97.1718 112.908 97.4721L114.881 98.0121C115.978 98.3124 117.123 98.3926 118.252 98.2478L120.28 97.9876C121.408 97.8429 122.554 97.923 123.651 98.2233L124.637 98.4933",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6187 91.2051L98.8046 91.0619C99.8912 90.9307 100.993 91.0077 102.051 91.2889L104.359 91.9026C105.417 92.1838 106.519 92.2608 107.606 92.1296L109.977 91.8432C111.064 91.712 112.166 91.789 113.223 92.0702L115.532 92.6839C116.59 92.965 117.692 93.0421 118.778 92.9109L121.15 92.6245C122.237 92.4932 123.338 92.5703 124.396 92.8514L125.55 93.1583",
    stroke: "#57B2E8",
    strokeWidth: 2.15383
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M131.673 82.7913L131.265 82.7628C129.057 82.6084 127.091 84.152 126.718 86.3334L124.382 99.984C124.009 102.165 122.043 103.709 119.836 103.555L101.83 102.296C99.6226 102.141 97.8911 100.339 97.825 98.127L97.4116 84.2841C97.3456 82.072 95.614 80.2698 93.4063 80.1155L92.998 80.0869",
    stroke: "#2C94DA",
    strokeWidth: 2.15383,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 179.83,
    y: 37.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 179.83 37.8706)",
    fill: "#D5EEFC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 179.83,
    y: 37.8706,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(8 179.83 37.8706)",
    stroke: "#79C7F4",
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M190.062 63.4073L188.896 63.458L188.473 74.0233C188.398 75.9187 189.77 77.5632 191.649 77.8272L206.969 79.9803C208.848 80.2443 210.62 79.0419 211.07 77.1991L213.576 66.9266L212.469 66.5565C211.612 66.2698 210.709 66.1429 209.806 66.1822L207.474 66.2837C206.571 66.323 205.668 66.1961 204.811 65.9094L202.597 65.169C201.74 64.8823 200.837 64.7554 199.934 64.7947L197.602 64.8962C196.699 64.9355 195.796 64.8086 194.939 64.5219L192.725 63.7816C191.868 63.4949 190.965 63.368 190.062 63.4073Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M203.099 51.9375L202.199 58.3362",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M203.42 49.6533L201.878 60.6224",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M207.784 53.0625L197.514 57.212",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M198.285 51.7275L207.014 58.5471",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.525 72.7276L189.4 72.6769C190.373 72.6207 191.348 72.7577 192.268 73.0801L193.922 73.6597C194.842 73.9821 195.817 74.1191 196.791 74.0628L198.541 73.9616C199.514 73.9053 200.489 74.0423 201.409 74.3647L203.063 74.9444C203.983 75.2668 204.958 75.4038 205.931 75.3475L207.682 75.2463C208.655 75.19 209.63 75.327 210.55 75.6494L211.377 75.9392",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M188.71 68.0928L189.733 68.0412C190.67 67.994 191.607 68.1258 192.495 68.4294L194.432 69.0922C195.32 69.3959 196.257 69.5276 197.194 69.4804L199.239 69.3773C200.176 69.3301 201.114 69.4618 202.001 69.7655L203.939 70.4283C204.826 70.7319 205.764 70.8637 206.701 70.8165L208.746 70.7134C209.683 70.6661 210.62 70.7979 211.508 71.1015L212.477 71.4329",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M218.331 62.9344L217.984 62.8856C216.105 62.6216 214.332 63.8239 213.883 65.6668L211.069 77.1992C210.62 79.0421 208.847 80.2444 206.968 79.9804L191.648 77.8273C189.77 77.5633 188.397 75.9188 188.473 74.0234L188.947 62.1623C189.022 60.2669 187.65 58.6224 185.771 58.3584L185.424 58.3096",
    stroke: "#2C94DA",
    strokeWidth: 1.84614,
    strokeLinecap: "round"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 53.6775,
    y: 26.8559,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 53.6775 26.8559)",
    fill: "#D5EEFC"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 53.6775,
    y: 26.8559,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(9 53.6775 26.8559)",
    stroke: "#79C7F4",
    strokeWidth: 2
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4618 52.5671L62.295 52.5975L61.6883 63.1538C61.5794 65.0476 62.9233 66.7157 64.7969 67.0125L80.0773 69.4326C81.9509 69.7294 83.7445 68.5582 84.2262 66.7234L86.9112 56.4963L85.8109 56.1068C84.9588 55.8052 84.0584 55.6626 83.1547 55.6861L80.8212 55.7469C79.9175 55.7704 79.0172 55.6278 78.165 55.3262L75.9645 54.5473C75.1123 54.2457 74.2119 54.1031 73.3082 54.1266L70.9747 54.1874C70.071 54.2109 69.1707 54.0683 68.3185 53.7667L66.118 52.9878C65.2658 52.6861 64.3654 52.5435 63.4618 52.5671Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6963 41.3271L75.6855 47.7091",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0576 39.0479L75.3248 49.9884",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3613 42.5332L71.0204 46.5029",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8877 41.0332L80.4958 48.0041",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7628 61.8592L62.6385 61.8239C63.6127 61.7846 64.585 61.9386 65.4993 62.277L67.1433 62.8854C68.0576 63.2238 69.03 63.3778 70.0041 63.3385L71.7556 63.2679C72.7298 63.2286 73.7021 63.3826 74.6165 63.721L76.2604 64.3294C77.1748 64.6678 78.1471 64.8218 79.1212 64.7825L80.8728 64.7119C81.8469 64.6726 82.8192 64.8266 83.7336 65.165L84.5556 65.4692",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.0294 57.2283L63.0527 57.1946C63.9903 57.1638 64.9252 57.3118 65.8075 57.6309L67.7331 58.3275C68.6153 58.6466 69.5502 58.7946 70.4879 58.7638L72.5345 58.6964C73.4721 58.6655 74.4071 58.8136 75.2893 59.1327L77.2149 59.8292C78.0971 60.1483 79.032 60.2964 79.9697 60.2655L82.0163 60.1982C82.9539 60.1673 83.8889 60.3154 84.7711 60.6345L85.7339 60.9827",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M91.7367 52.5881L91.3902 52.5332C89.5166 52.2365 87.723 53.4077 87.2413 55.2424L84.2269 66.724C83.7452 68.5587 81.9516 69.7299 80.078 69.4332L64.7976 67.013C62.9241 66.7163 61.5802 65.0481 61.689 63.1543L62.3702 51.3032C62.479 49.4094 61.1351 47.7413 59.2615 47.4445L58.915 47.3896",
    stroke: "#2C94DA",
    strokeWidth: 1.84614,
    strokeLinecap: "round"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 137.275,
    y: 16.9166,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 137.275 16.9166)",
    fill: "#D5EEFC"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 137.275,
    y: 16.9166,
    width: 50,
    height: 50,
    rx: 25,
    transform: "rotate(5 137.275 16.9166)",
    stroke: "#79C7F4",
    strokeWidth: 2
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M148.829 41.8832L147.667 41.9949L147.798 52.5678C147.821 54.4646 149.278 56.035 151.168 56.2003L166.58 57.5487C168.47 57.714 170.177 56.4205 170.53 54.5566L172.495 44.1671L171.37 43.8554C170.499 43.6139 169.591 43.5345 168.691 43.621L166.368 43.8444C165.468 43.9309 164.56 43.8514 163.689 43.61L161.439 42.9865C160.568 42.7451 159.66 42.6656 158.76 42.7521L156.436 42.9755C155.536 43.062 154.628 42.9826 153.757 42.7411L151.508 42.1176C150.637 41.8762 149.728 41.7967 148.829 41.8832Z",
    fill: "#75C5F4",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M161.248 29.7461L160.685 36.183",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M161.449 27.4473L160.484 38.482",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M165.985 30.625L155.947 35.3063",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M156.431 29.7881L165.504 36.1415",
    stroke: "#2C94DA",
    strokeWidth: 1.84615
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M147.782 51.2713L148.653 51.175C149.622 51.0678 150.603 51.1536 151.539 51.4274L153.221 51.9197C154.157 52.1935 155.137 52.2793 156.107 52.1722L157.849 51.9795C158.818 51.8723 159.799 51.9581 160.734 52.2319L162.417 52.7242C163.352 52.998 164.333 53.0838 165.302 52.9767L167.044 52.784C168.014 52.6769 168.994 52.7626 169.93 53.0365L170.771 53.2826",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M147.724 46.6326L148.743 46.5276C149.676 46.4314 150.619 46.5139 151.521 46.7707L153.491 47.3312C154.393 47.588 155.336 47.6705 156.269 47.5743L158.306 47.3643C159.24 47.2681 160.183 47.3506 161.085 47.6074L163.054 48.1679C163.957 48.4247 164.9 48.5072 165.833 48.411L167.87 48.201C168.803 48.1048 169.746 48.1873 170.648 48.4441L171.633 48.7244",
    stroke: "#57B2E8",
    strokeWidth: 1.84614
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M177.036 39.9314L176.686 39.9008C174.797 39.7355 173.089 41.029 172.737 42.8929L170.531 54.5567C170.178 56.4206 168.47 57.7141 166.581 57.5488L151.169 56.2004C149.279 56.0351 147.822 54.4647 147.799 52.5679L147.651 40.6982C147.628 38.8014 146.171 37.2311 144.281 37.0657L143.932 37.0352",
    stroke: "#2C94DA",
    strokeWidth: 1.84614,
    strokeLinecap: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62 92C62 90.8954 62.8954 90 64 90H84.2654C85.2607 90 86.1046 90.7319 86.2453 91.7172L89.7547 116.283C89.8954 117.268 90.7393 118 91.7346 118H192.265C193.261 118 194.105 117.268 194.245 116.283L197.755 91.7172C197.895 90.7319 198.739 90 199.735 90H220C221.105 90 222 90.8954 222 92V118V144C222 145.105 221.105 146 220 146H190H94H64C62.8954 146 62 145.105 62 144V118V92Z",
    fill: "#5AB1E2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 115.5,
    r: 1.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 40.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 253.5,
    cy: 41.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 280.5,
    cy: 111.5,
    r: 1.5,
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 7.5,
    r: 1.5,
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 16.5L47.5 21.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M42 76.5L17 81.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.04,
    width: 216,
    height: 4,
    rx: 2,
    transform: "matrix(1 0 0 -1 34 150)",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M220 20.5L239.5 13",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M238.5 79.5L255.5 82",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectiveColdPlunge);
export default __webpack_public_path__ + "static/media/collective-cold-plunge.ad4c0d23a57f3b8c759390d3158871ac.svg";
export { ForwardRef as ReactComponent };